import React, { useState } from "react";
import "moment/locale/fa";
import PersianDatePicker from "../Events/NewRangePicker"


const RangePickerAnalyse = ({ dateHOC, setDateHOC }) => {
  const [date, setDate] = useState(dateHOC);
  const handleRangeChange = (selectedDates) => {
    if (!selectedDates || selectedDates.length !== 2) return;

    setDate(selectedDates);

    // const start = moment(selectedDates[0], "jYYYY-jMM-jDD").startOf("day").toDate();
    // const end = moment(selectedDates[1], "jYYYY-jMM-jDD").endOf("day").toDate();

    // console.log(start.toISOString(), end.toISOString());

    // فرستادن به parent
    setDateHOC(selectedDates);
  };


  return (
    <div>

      <PersianDatePicker dateHOC={date} onRangeChange={date => handleRangeChange(date)} />
    </div>)

};

export default RangePickerAnalyse;
